// Ajce Hostel App React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { StudentListTable } from "./components/studentListTable";

function StudentsList() {
 
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <StudentListTable />
      <Footer />
    </DashboardLayout>
  );
}

export default StudentsList;
